/**
 * Pre-compiled fr-FR messages for TagGroup
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { removeTag: `Supprimer la balise` };
